import React from 'react'
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import PunchClockIcon from '@mui/icons-material/PunchClock';
import EmailIcon from '@mui/icons-material/Email';

export default function Branches() {
  return (
    <div className='branch__main'>
      
<div className='branchcard'>

<h2>  Yummi Mormona </h2>
<LocationOnIcon style={{color: "orange"}}/>
<h6> 88566 Mormona Road, New York, NY 12845 </h6>
<PhoneIcon style={{color: "orange"}}/>
<h6> +183-3494 343 </h6>
<EmailIcon style={{color: "orange"}}/>
<h6> mail@gmail.com </h6>

<PunchClockIcon style={{color: "orange"}}/>
<h6> Mon - Fri </h6>
<p> 8am-11pm </p>

<h6> Sat - Sun </h6>
<p> 8am-2pm </p>

</div>

<div className='branchcard'>

<h2>  Yummi Mormona </h2>
<LocationOnIcon style={{color: "orange"}}/>
<h6> 88566 Mormona Road, New York, NY 12845 </h6>
<PhoneIcon style={{color: "orange"}}/>
<h6> +183-3494 343 </h6>
<EmailIcon style={{color: "orange"}}/>
<h6> mail@gmail.com </h6>

<PunchClockIcon style={{color: "orange"}}/>
<h6> Mon - Fri </h6>
<p> 8am-11pm </p>

<h6> Sat - Sun </h6>
<p> 8am-2pm </p>

</div>

<div className='branchcard'>

<h2>  Yummi Mormona </h2>
<LocationOnIcon style={{color: "orange"}}/>
<h6> 88566 Mormona Road, New York, NY 12845 </h6>
<PhoneIcon style={{color: "orange"}}/>
<h6> +183-3494 343 </h6>
<EmailIcon style={{color: "orange"}}/>
<h6> mail@gmail.com </h6>

<PunchClockIcon style={{color: "orange"}}/>
<h6> Mon - Fri </h6>
<p> 8am-11pm </p>

<h6> Sat - Sun </h6>
<p> 8am-2pm </p>

</div>

    </div>
  )
}
